import axios from 'axios'
import store from './index.js'

// let url = 'http://localhost:3000/druzbamebel'
const url = 'https://sitebypro-server.ru/druzbamebel'

export default {
  state: {
    choosen_address: null
  },
  getters: {
    choosen_address(state) {
      return state.choosen_address
    }
  },
  mutations: {
    CHOOSE_ADDRESS(state, data) {
      state.choosen_address = data || null
    },
    DELETE_ADDRESS(state, data) {
      store.commit('DELETE_USER_ADDRESSES', data)
    },
    CHANGE_ADDRESS(state, data) {
      store.commit('CHANGE_USER_ADDRESSES', data)
    },
    ADD_ADDRESS(state, data) {
      store.commit('ADD_USER_ADDRESSES', data)
    }
  },
  actions: {
    async GET_DELIVERY_PRICE(context, data) {
      return axios.post(url + '/user/get-delivery-price', data)
    },
    async ADD_ADDRESS({ commit }, data) {
      commit('ADD_ADDRESS', data)
      const response = await axios.post(url + '/user/add-address', data)
      if (!response.data || response.data.status !== '200') throw new Error('Не удалось добавить адрес')
      return response.data
    },
    async CHANGE_ADDRESS({ commit }, data) {
      commit('CHANGE_ADDRESS', data)
      const response = await axios.post(url + '/user/change-address', data)
      if (!response.data || response.data.status !== '200') throw new Error('Не удалось изменить адрес')
      return response.data
    },
    async DELETE_ADDRESS({ commit }, data) {
      commit('DELETE_ADDRESS', data)
      const response = await axios.post(url + '/user/delete-address', data)
      if (!response.data || response.data.status !== '200') throw new Error('Не удалось удалить адрес')
      return response.data
    },
    async GET_DADATA_ADDRESS(context, payload) {
      const request = typeof payload === 'string'
        ? { query: payload, count: 10 }
        : { query: payload && payload.query, count: payload && payload.count }

      const query = String(request.query || '').trim()
      if (query.length < 3) return []

      try {
        const response = await axios.post(url + '/equipment/get-address', {
          query,
          count: Number(request.count) === 1 ? 1 : 10
        }, { timeout: 7000 })

        const body = response.data || {}
        if (String(body.code) !== '200') throw new Error(body.message || 'Сервис адресов временно недоступен')
        return body.data && Array.isArray(body.data.suggestions) ? body.data.suggestions : []
      } catch (error) {
        const serverMessage = error && error.response && error.response.data && error.response.data.message
        throw new Error(serverMessage || 'Не удалось получить подсказки адресов. Попробуйте ещё раз.')
      }
    }
  }
}
